import {h, Fragment} from "preact"
import { useProductFilters, useAppState } from "@nosto/preact";

function FilterRemoveButton({ filter, className }) {
  return (
    <button
      className={`ns-remove-selected-filter ${className}`}
      onClick={() => filter.remove()}
    >
      X
    </button>
  );
}

export default function SelectedFilters() {
  const { filters, removeAll } = useProductFilters();
  const { query, response } = useAppState();
  let isMobile = window.innerWidth < 769;

  return (
    <>
      {filters.length > 0 && (
        <div class="ns-filter-tags-category ns-w-100">
          <div class="ns-selected-filters-container ns-align-items-center">
            {filters.map((filter) => (
              <div class="ns-selected-filter">
                <FilterRemoveButton filter={filter} />
                <span class="">{filter.value.replace("%2F", "/")}</span>
              </div>
            ))}
            <a
              href="javascript:void(0)"
              class="ns-remove-all-btn"
              onClick={() => {
                removeAll();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <mask
                  id="mask0_4589_20362"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                >
                  <rect y="9.15527e-05" width="20" height="20" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_4589_20362)">
                  <path
                    d="M10.0638 15.8334C8.43533 15.8334 7.05596 15.2686 5.92568 14.1388C4.79554 13.0091 4.23047 11.6304 4.23047 10.0026C4.23047 8.3748 4.79554 6.99522 5.92568 5.86383C7.05596 4.73244 8.43533 4.16675 10.0638 4.16675C11.0541 4.16675 11.9814 4.40203 12.8459 4.87258C13.7102 5.34328 14.4067 6.00008 14.9355 6.843V4.16675H15.7688V8.52571H11.4098V7.69237H14.4932C14.0594 6.86112 13.4492 6.2046 12.6623 5.72279C11.8754 5.24098 11.0092 5.00008 10.0638 5.00008C8.67491 5.00008 7.49436 5.48619 6.52214 6.45841C5.54991 7.43064 5.0638 8.61119 5.0638 10.0001C5.0638 11.389 5.54991 12.5695 6.52214 13.5417C7.49436 14.514 8.67491 15.0001 10.0638 15.0001C11.1332 15.0001 12.0985 14.6945 12.9596 14.0834C13.8207 13.4723 14.4249 12.6667 14.7721 11.6667H15.6567C15.2892 12.9147 14.591 13.9211 13.5621 14.6859C12.5332 15.4509 11.3671 15.8334 10.0638 15.8334Z"
                    fill="#333333"
                  />
                </g>
              </svg>
              Clear filters
            </a>
          </div>
        </div>
      )}
    </>
  );
}
